import './InfoWindow.css';

import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { Close } from '@mui/icons-material';
import Banner from './Banner';
import { getIconWithTooltip } from '../b2b-plans/components/helper';
import { generateClassName } from './helpers';

const InfoWindow = ({ top, right, width, minHeight, windowTitle, windowContent, handleClose, className, secondsOpen = 10 }) => {
    useEffect(() => {
        let timer;
        if (secondsOpen > 0) {
            timer = setTimeout(() => {
                handleClose();
            }, secondsOpen * 1000);
        }
        return () => clearTimeout(timer);
    }, [secondsOpen, handleClose]);

    return (
        <Box className={generateClassName('info-window', '', className)}
            style={{ top, right, width, minHeight }}
        >
            <Box className={generateClassName('info-window', '-content', className)}>
                <Banner sectionTittle={windowTitle} headingLevel='h3' underline={false} />
                {windowContent}
                {getIconWithTooltip(Close, { cursor: 'pointer', position: 'absolute', top: '10px', right: '10px', color: '#011d89' }, 'Close', null, handleClose)}
            </Box>
        </Box>
    );
};

export default InfoWindow;